import VueTypes, { nullable } from 'vue-types'

// MODEL: CategoryLink
export const CategoryLink = VueTypes.shape({
    name: VueTypes.string.isRequired,    
    route: VueTypes.string.isRequired,
}).isRequired

export const createCategoryLink = ({
    name, route
}) => {
    return {
        name: name,
        route: route,
    }
}

// MODEL: ParentCategoryItem
export const ParentCategoryItem = VueTypes.shape({
    name: VueTypes.string.isRequired,    
    route: VueTypes.string.isRequired,
    img : VueTypes.oneOfType([String, nullable]).isRequired,
}).isRequired

export const createParentCategoryItem = ({
    name, route, img = null
}) => {
    return {
        name: name,
        route: route,
        img: img,
    }
}